import {
  doc,
  getDoc,
  collection,
  query,
  orderBy,
  limit,
  getDocs,
} from 'firebase/firestore';
import firestore from './firestore';
import logger from './logger';

export default async function getLatestBuildId({
  appId,
  userId,
}: {
  appId: string;
  userId: string;
}): Promise<string | undefined> {
  logger.debug({ appId }, 'getLatestBuildId');
  const appRef = doc(firestore, `users/${userId}/applications/${appId}`);
  const appSnapshot = await getDoc(appRef);

  if (!appSnapshot.exists()) {
    throw new Error(`Application with ID of ${appId} doesn't exist.`);
  }

  const buildsQuery = query(
    collection(firestore, `users/${userId}/applications/${appId}/builds`),
    orderBy('createdAt', 'desc'),
    limit(1),
  );
  const buildsResult = await getDocs(buildsQuery);

  return buildsResult.empty ? undefined : buildsResult.docs[0].id;
}
